import clsx from 'clsx'

import { Post } from '@tribeplatform/gql-client/types'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'

import type { StaticField } from '../../Views/types'

interface Props {
  field: StaticField
  post: Post
  highlighted: boolean
  mediaUrl: string
}
export const ListAvatar = ({ field, post, highlighted, mediaUrl }: Props) => {
  return (
    <div className="shrink-0">
      <Avatar
        size={field.settings?.avatarSize ?? 'lg'}
        src={mediaUrl}
        name={post?.owner?.member?.name}
        className={clsx(
          highlighted && 'ring-2 ring-offset-surface ring-focused',
        )}
      />
    </div>
  )
}
